import React from "react";
import styles from './styles.module.scss';
import { Input } from "../input";
import { Selector } from "../selector";
import { FileUpload } from "../file-upload";
import { Loading } from "../loading";
import { sendPartnershipFormData } from "../../request-service";
import { useTurnstile } from "../../hooks/useTurnstile";

export function PartnershipForm() {
    const defaultFormData = { massageType: '', name: '', email: '', message: '', files: [] };

    const [formData, setFormData] = React.useState(defaultFormData);
    const [loading, setLoading] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const { turnstileToken, turnstileRef, isCaptchaConfigured, resetTurnstile } = useTurnstile();

    async function handleFormSubmit(event) {
        event.preventDefault();

        if (!turnstileToken) {
            setErrorMessage('Please complete the captcha.');
            return;
        }

        setLoading(true);
        setErrorMessage('');

        const uploadFormData = new FormData();
        const { files, ...restFormData } = formData;

        for (const key in restFormData) {
            if (restFormData.hasOwnProperty(key)) uploadFormData.append(key, restFormData[key]);
        }

        if (files) files.forEach((file) => uploadFormData.append('file', file));

        uploadFormData.append('formType', 'partnership');
        uploadFormData.append('turnstileToken', turnstileToken);

        try {
            await sendPartnershipFormData(uploadFormData);
            setFormData(defaultFormData);
            setLoading(false);
            setSuccessMessage('Your partnership data was successfully sent.');
            resetTurnstile();
        } catch (error) {
            setLoading(false);
            setErrorMessage(error?.message || 'Something went wrong, please try again later');
            resetTurnstile();
        }
    }

    function filterFiles(files) {
        const validExt = ['pdf', 'odt', 'ppt', 'pptx', 'key', 'doc', 'docx', 'rtf', 'wpd', 'apk'];
        return Array.from(files).filter(f => {
            const parts = f.name.split('.');
            return validExt.includes(parts[parts.length - 1]);
        });
    }

    function handleFormChange({ target }) {
        let value = target.value;
        if (target.files) {
            value = formData.files;
            Array.prototype.push.apply(value, filterFiles(target.files));
            value = value.slice(0, 3);
        }
        setFormData({ ...formData, [target.name]: value });
    }

    function handleFormSelector(data, event) { setFormData({ ...formData, [event.name]: data.value }); }

    function handleFileUploadFileRemove(file) {
        const copy = [...formData.files];
        const idx = copy.indexOf(file);
        if (idx > -1) { copy.splice(idx, 1); setFormData({ ...formData, files: copy }); }
    }

    function handleMessageClose() { setErrorMessage(''); setSuccessMessage(''); }

    return (
        <div className={styles.partnershipForm}>
            <Loading isLoading={loading} errorMessage={errorMessage} successMessage={successMessage} onMessageClose={handleMessageClose} />
            <form onSubmit={handleFormSubmit} onChange={handleFormChange}>
                <div className={styles.separated}>
                    <div><Input label="Name" value={formData.name} name="name" id="name" /></div>
                    <div><Input label="Email" value={formData.email} name="email" id="email" type="email" /></div>
                </div>
                <Input label="Message" value={formData.message} name="message" id="message" isTextarea />
                <div className={styles.formTextBlock}>
                    <h3>Presentation and documentation</h3>
                    <p>Upload files: pdf, odt, ppt, pptx, key, doc, docx, rtf, wpd, apk. Up to 3 files.</p>
                </div>
                <FileUpload name='files' files={formData.files} onFileRemove={handleFileUploadFileRemove} required />
                <div className={styles.bottom}>
                    <div style={{ marginBottom: '16px' }}>
                        {isCaptchaConfigured ? <div ref={turnstileRef} /> : <div style={{color:'red'}}>Captcha configuration error.</div>}
                    </div>
                    <div className="formSubmitButtonErrorsWrap contactFormButton">
                        <input type="submit" className="buttonWrap button button-green contactSubmitButton" value="Send Message" />
                    </div>
                </div>
            </form>
        </div>
    );
}